define('controllers/fieldHTML',[], function() {
    var controller = Marionette.Object.extend({

        htmlFields: [],
        trackedMergeTags: [],

        initialize: function () {
            this.listenTo( Backbone.Radio.channel( 'fields-html' ), 'init:model', this.setupFieldMergeTagTracking );
        },

        setupFieldMergeTagTracking: function( fieldModel ) {
            this.htmlFields.push( fieldModel );

            var formID = fieldModel.get( 'formID' );
            var self = this;

            this.listenTo( nfRadio.channel( 'form-' + formID ), 'init:model', function( formModel ){

                var mergeTags = fieldModel.get( 'default' ).match( new RegExp( /{field:(.*?)}/g ) );
                if ( ! mergeTags ) return;

                _.each( mergeTags, function( mergeTag ) {
                    var fieldKey = mergeTag.replace( '{field:', '' ).replace( '}', '' );
                    var fieldModel = formModel.get( 'fields' ).findWhere({ key: fieldKey });
                    if( 'undefined' == typeof fieldModel ) return;

                    this.trackedMergeTags.push( fieldModel );
                    this.listenTo( nfRadio.channel( 'field-' + fieldModel.get( 'id' ) ), 'change:modelValue', this.updateFieldMergeTags );
                    
                    // Special handling for repeater fields
                    if (fieldModel.get('type') === 'repeater') {
                        // Listen to all field changes to catch repeater sub-field updates
                        this.listenTo( nfRadio.channel( 'fields' ), 'change:modelValue', function(changedField) {
                            
                            // Check if this is a sub-field of our repeater
                            var changedKey = changedField.get('key');
                            if (changedKey && changedKey.indexOf(fieldKey + '_') === 0) {
                                // This is a sub-field of our repeater, trigger update
                                self.updateFieldMergeTags(fieldModel);
                            }
                        });
                    }
                }, this );

                // Let's get this party started!
                this.updateFieldMergeTags();
            }, this );
        },

        updateFieldMergeTags: function( fieldModel ) {
            var self = this;
            _.each( this.htmlFields, function( htmlFieldModel ){
                // Get the current HTML field value
                var value = htmlFieldModel.get( 'value' ) || htmlFieldModel.get( 'default' ) || '';
                
               _.each( self.trackedMergeTags, function( fieldModel ){

                   /* Search the value for any spans with mergetag data-key
                   * values
                   */
                   var spans = value.match( new RegExp( /<span data-key="field:(.*?)<\/span>/g ) );
	               _.each( spans, function( spanVar ) {
	                   /* See if the span string contains the current
                       * fieldModel's key. If so replace the span with a
                       * merge tag for evaluation.
                       */
                       if( -1 < spanVar.indexOf( "data-key=\"field:" + fieldModel.get( 'key' ) ) ) {
	                       value = value.replace( spanVar, "{field:" + fieldModel.get( 'key' ) + "}" );
                       }
	               } );

                    var mergeTag = '{field:' + fieldModel.get( 'key' ) + '}';

                    let fieldValue;
                    // Handle different field types
                    if (fieldModel.get('type') === "repeater") {
                        fieldValue = self.displayRepeaterData(fieldModel);
                    } else if (fieldModel.get('type') === "signature") {
                        fieldValue = self.displaySignatureData(fieldModel);
                    } else {
                        fieldValue = fieldModel.getValue();
                    }

	               /* We replace the merge tag with the value
	               * surrounded by a span so that we can still find it
	               * and not affect itself or other field merge tags
	               */
                    value = value.replace( mergeTag, "<span data-key=\"field:"
                        + fieldModel.get( 'key' ) + "\">"
                        + fieldValue + "</span>" );
               }) ;
               htmlFieldModel.set( 'value', value );
               htmlFieldModel.trigger( 'reRender' );
            });
        },

        displayRepeaterData: function(fieldModel) {
                // Get the current value which contains all sub-field IDs
                var repeaterValue = fieldModel.getValue();
                if (!repeaterValue || typeof repeaterValue !== 'object') {
                    return '';
                }
                
                const repeaterFieldIDs = Object.keys(repeaterValue);
                let returnHTML = "", passedFields = [];

                _.each(repeaterFieldIDs, function(fieldID){
                    if(passedFields.indexOf(fieldID) === -1) {
                        const field = nfRadio.channel( 'fields' ).request( 'get:field', fieldID );
                        if(typeof field !== "undefined"){
                            const excluded = ['submit', 'html', 'hidden', 'password', 'passwordconfirm', 'divider', 'hr', 'note', 'unknown', 'button', 'confirm', 'creditcard', 'creditcardcvc', 'creditcardexpiration', 'creditcardfullname', 'creditcardnumber', 'creditcardzip', 'recaptcha', 'recaptcha_v3' ];
                            if(excluded.indexOf(field.get('type')) === -1 && field.getValue().toString().length > 0){
                                const index = Number(fieldID.split("_").pop()) + 1;
                                
                                let fieldValue;
                                if (field.get('type') === 'signature') {
                                    fieldValue = this.displaySignatureData(field);
                                } else {
                                    fieldValue = field.getValue();
                                }
                                
                                returnHTML += "<p>"+ field.get("label") + " " + index + " : " + fieldValue + "</p>";
                                passedFields.push(fieldID);
                            } 
                        }
                    }
                }, this);

                return returnHTML;
        },

        /**
         * Display signature field data as HTML image or styled text
         * 
         * @param {Object} fieldModel The signature field model
         * @returns {string} HTML string containing the signature display
         */
        displaySignatureData: function(fieldModel) {
            var value = fieldModel.getValue();
            
            // Return empty if no value
            if (!value || value === '') {
                return '';
            }
            
            // Try to parse JSON data
            var signatureData;
            try {
                // If it's already an object, use it directly
                if (typeof value === 'object') {
                    signatureData = value;
                } else if (typeof value === 'string' && value.charAt(0) === '{') {
                    // Parse JSON string
                    signatureData = JSON.parse(value);
                } else {
                    // Not JSON, return as-is
                    return value;
                }
            } catch (e) {
                // If JSON parsing fails, return the original value
                console.warn('Failed to parse signature data:', e);
                return value;
            }
            
            // Check if we have valid signature data
            if (!signatureData || !signatureData.signature_type) {
                return value;
            }
            
            // Handle typed signatures
            if (signatureData.signature_type === 'typed' && signatureData.typed_name) {
                // Get font from field settings first, then signature data, then default
                // This ensures the HTML field merge tag uses the field's configured font
                var configuredFont = fieldModel.get('signature_font');
                var font = configuredFont || signatureData.signature_font || 'dancing-script';
                var fontFamily = this.getSignatureFontFamily(font);

                return '<div class="nf-signature-typed" style="font-family: ' + fontFamily + '; font-size: 28px; color: #000000; padding: 10px 0;">' +
                       _.escape(signatureData.typed_name) +
                       '</div>';
            }
            
            // Handle drawn signatures
            if (signatureData.signature_type === 'drawn' && signatureData.signature_data) {
                // Ensure the signature data is a valid data URI
                if (signatureData.signature_data.indexOf('data:image') === 0) {
                    return '<img class="nf-signature-drawn" src="' + _.escape(signatureData.signature_data) + '" ' +
                           'alt="Signature" style="max-width: 400px; height: auto; display: block;" />';
                }
            }
            
            // If we couldn't process the signature, return empty
            return '';
        },
        
        /**
         * Get the appropriate font family for signature display
         * Matches the valid fonts defined in PHP (Signature.php VALID_FONTS constant)
         * Uses single quotes to avoid HTML escaping issues
         *
         * @param {string} font The font identifier
         * @returns {string} CSS font-family value
         */
        getSignatureFontFamily: function(font) {
            var fontMap = {
                'dancing-script': '\'Dancing Script\', cursive',
                'satisfy': '\'Satisfy\', cursive',
                'cursive': 'cursive'
            };

            return fontMap[font] || fontMap['dancing-script'];
        },
        

    });

    return controller;
});

